import { render, staticRenderFns } from "./OrdersRoundView.vue?vue&type=template&id=0139a57d&"
import script from "./OrdersRoundView.vue?vue&type=script&lang=js&"
export * from "./OrdersRoundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports